import { render, staticRenderFns } from "./AdminProjects.vue?vue&type=template&id=3093d65c&scoped=true&"
import script from "./AdminProjects.vue?vue&type=script&lang=js&"
export * from "./AdminProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3093d65c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3093d65c')) {
      api.createRecord('3093d65c', component.options)
    } else {
      api.reload('3093d65c', component.options)
    }
    module.hot.accept("./AdminProjects.vue?vue&type=template&id=3093d65c&scoped=true&", function () {
      api.rerender('3093d65c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Workspace/AdminPage/AdminProjects.vue"
export default component.exports